import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function LoginAsUserPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    localStorage.setItem("token", token);

    window.location.href = "/";
  }, []);

  return null;
}
